import { useEffect, useState } from "react";
import { getCurrentLanguage } from "../i18n";
import { translate } from "../i18n";

export default function useTranslate() {
  const [lang, setLang] = useState(getCurrentLanguage());

  useEffect(() => {
    const handleLanguageChange = (e) => {
      setLang(e?.detail || getCurrentLanguage());
    };

    const handleStorage = () => {
      setLang(getCurrentLanguage());
    };

    window.addEventListener("language-changed", handleLanguageChange);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("language-changed", handleLanguageChange);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  const t = (key) => translate(key, lang);

  return { t, lang };
}